import { connect } from 'react-redux'
import PickANumber from './PickANumber'
import showNumbersFormModal from 'features/Numbers/NumbersFormModal'

const mapStateToProps = () => ({})

const dispatchToProps = {
  showNumbersFormModal,
}

export default connect(mapStateToProps, dispatchToProps)(PickANumber)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/PickANumber/PickANumber.container.jsx